import { render, staticRenderFns } from "./DependentsExpansion.vue?vue&type=template&id=28d3e5cd&"
import script from "./DependentsExpansion.vue?vue&type=script&lang=js&"
export * from "./DependentsExpansion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports